// Tooltips
import { Tooltip } from '../../utils/Tooltip';

document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.js-tooltip')).forEach((element) => {
        const tooltip = new Tooltip(element);
        tooltip.init();
    });
});
